import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const { FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { language, t, toggleLanguage } = useLanguage();

  const isActive = (path) => location.pathname === path;

  const menuItems = [
    { name: t.nav.home, path: '/' },
    { name: t.nav.headhunter, path: '/ai-headhunter' },
    { name: t.nav.platforms, path: '/platforms' },
    { name: t.nav.vision, path: '/visie' },
  ];

  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-brand-orange rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-xl text-brand-orange-logo">V</span>
            </div>
            <span className="text-2xl font-black text-brand-dark tracking-tighter">vacature.ai</span>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-1 py-2 text-sm font-bold uppercase tracking-widest transition-colors ${
                  isActive(item.path) ? 'text-brand-orange' : 'text-gray-500 hover:text-brand-orange'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-6">
            <div className="flex items-center gap-2 text-[10px] font-black text-gray-400">
              <button 
                onClick={() => toggleLanguage('en')}
                className={`hover:text-brand-orange transition-colors ${language === 'en' ? 'text-brand-orange underline' : ''}`}
              >
                EN
              </button>
              <span className="opacity-30">|</span>
              <button 
                onClick={() => toggleLanguage('nl')}
                className={`hover:text-brand-orange transition-colors ${language === 'nl' ? 'text-brand-orange underline' : ''}`}
              >
                NL
              </button>
            </div>
            <Link
              to="/ai-headhunter"
              className="bg-brand-orange text-white px-6 py-3 rounded-xl text-xs font-black uppercase tracking-widest hover:bg-orange-600 transition-all shadow-lg hover:-translate-y-0.5"
            >
              {t.nav.cta}
            </Link>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 text-gray-600 hover:text-brand-orange transition-colors"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
          </button>
        </div>

        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="lg:hidden border-t border-gray-100 py-6 bg-white"
            >
              <nav className="space-y-2 px-2">
                {menuItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`block px-4 py-3 rounded-xl text-sm font-black uppercase tracking-widest transition-colors ${
                      isActive(item.path) ? 'bg-orange-50 text-brand-orange' : 'text-gray-600 hover:bg-gray-50'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                ))}
                <div className="flex items-center gap-4 px-4 py-4 border-t border-gray-50 mt-4">
                   <button onClick={() => toggleLanguage('en')} className={`text-xs font-black ${language === 'en' ? 'text-brand-orange' : 'text-gray-400'}`}>EN</button>
                   <button onClick={() => toggleLanguage('nl')} className={`text-xs font-black ${language === 'nl' ? 'text-brand-orange' : 'text-gray-400'}`}>NL</button>
                </div>
              </nav>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <style dangerouslySetInnerHTML={{ __html: `.text-brand-orange-logo { color: #FF5F1F !important; filter: brightness(0) invert(1); }` }} />
    </header>
  );
};

export default Header;